/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Filter_Empty_BodyInputs */

const en_filter_empty_body = /** @type {(inputs: Filter_Empty_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nothing matches ${i?.query}.`)
};

const de_filter_empty_body = /** @type {(inputs: Filter_Empty_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nichts passt zu ${i?.query}.`)
};

/**
* | output |
* | --- |
* | "Nothing matches {query}." |
*
* @param {Filter_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_empty_body = /** @type {((inputs: Filter_Empty_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Empty_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_empty_body(inputs)
	return en_filter_empty_body(inputs)
});